<app-carousel-banner></app-carousel-banner>
<app-content-card></app-content-card>
<app-content-area></app-content-area>
<app-carousel-card></app-carousel-card>
<!-- <app-carousel-card1></app-carousel-card1> -->
<app-content-area2 [solutionData]="solutionData"></app-content-area2>
<app-tab-content></app-tab-content>
<app-tab-content1></app-tab-content1>
<!-- <app-carousel-card2></app-carousel-card2> -->
<app-simple-form></app-simple-form>